// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__193er","title":"ClientReferral_title__1QR9S","itemText":"ClientReferral_itemText__10kmG"};